import React, {useEffect, useState} from "react";
import {moment} from "../../../../../../vendor";
import {userActions, useSelector} from "inbooma-api";
import {Biscuit} from "../../../../../utils";
import UserSelect from "./UserSelect";
import t from "../../../../helpers/t";


const FindUser = (props) => {
    const {clientId,dispatch,setUser,language, setUsers,setUsersPending, usersPending, setUserQuery, setReservationQuery, userQuery,setReservation, setReservations} = props;
    const _users = useSelector(state => state.users_data.users);
    let _queryState = {
        timeStamp: 0,
        value: ""
    }
    useEffect(() => {
        if(!usersPending || _users.success === ''){
            return;
        }
        if(_users.success === true){
            setUsers(_users.data);
        }
        setUsersPending(false);
    })
    const searchbarHandlerInside = (ev) => {
        setUser(null);
        setUsers(null);
        setUserQuery(ev.target.value);              // just storing the query
        searchbarHandler(ev);             // this should cause the api query
    };

    const resetQuery = () => {
        setUserQuery('');
        setUser(null);
        setUsers(null);
        searchbarHandler('');
    };

    const searchbarHandler = (ev) => {

        let q;
        if(typeof ev.target !== 'undefined') {
            q = ev.target.value.toLowerCase();
        } else {
            q = '';
        }
        if(q !== ""){
            setReservationQuery('');
            setReservation(null);
            setReservations(null);
        }
        const minLength = 3;
        if (q.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;
                if (diff > 700 && _queryState.value === q) {                  // no changes after the last 700 ms -> user finished input -> start request
                    dispatch(userActions.getUsers({
                        token: Biscuit.get('token'),
                        filter: {
                            'q': q,
                            'client_id': clientId
                        },
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }));
                    setUsersPending(true);
                }
            },800);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = q;
    };

    return (
        <>
        <div id="inb-c-main-access-bar__search" className="medium-5 float-left" style={{minWidth:"45%"}}>
            <label>{t('user')}</label>
            <input type="text" placeholder="Nutzer suchen" value={userQuery} className="inb-input--transparent inb-input--search float-left" onChange={searchbarHandlerInside} style={{maxWidth:'90%'}}/>

        {userQuery !== '' && <><div className="inb-search-close" onClick={resetQuery} style={{padding:"5px 10px 10px 10px"}}>
            <a href="#" className="unset-filter">
                <i className="fi fi-x"> </i>
            </a>
        </div></>}
    </div>

        </>);
};

export default FindUser;